// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Bp-z","imageAndVideoCount":"Cp-z","imageAndVideoContainer":"Dp-z","viewAllReviews":"Ep-z"};